import {PERSIST_ROLE_ASSIGNMENT} from '../../../utils/constants';
import api_access from '../../../api/apiInstance';
import {fetchAndStoreAccessToken, fetchTokenApi} from './fetchToken';

/**
 * Fetch all roles for the encompass instance
 */
export async function saveRoleAssignment(data:any): Promise<any> {
  try {
    const response = await api_access.post(PERSIST_ROLE_ASSIGNMENT,data);
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
}
